import Polygon from "@arcgis/core/geometry/Polygon";
import Graphic from "@arcgis/core/Graphic";
import Polyline from "@arcgis/core/geometry/Polyline";
import { DEFAULT_FILL_SYMBOL } from "./constants";
import { TGeometry } from "../../../common/types/common";
import { SimpleLineSymbol } from "@arcgis/core/symbols";

export const getPolygon = (geometry: any) => {
    const polygon = new Polygon(geometry);

    return new Graphic({
        geometry: polygon,
        symbol: DEFAULT_FILL_SYMBOL
    });
};

export const getPathFromGeometry = (geometry: TGeometry): Graphic => {
  const polyline = new Polyline({
    paths: geometry.rings,
    spatialReference: geometry.spatialReference ?? { wkid: 4326 },
  });

  const symbol = new SimpleLineSymbol({
    color: [255, 0, 0, 1],
    width: 2,
  });

  return new Graphic({
    geometry: polyline,
    symbol,
  });
};

export const getCombinedGeometry = (geometries: any) => Object.values(geometries).length
    ? Object.values(geometries).reduce<TGeometry>((acc, { rings, spatialReference }) => {
        if (!acc.spatialReference) {
            acc.spatialReference = spatialReference;
        }

        acc.rings.push(rings[0]);

        return acc;
    }, { spatialReference: null, rings: []})
    : null;

export const getSeparatedGeometries = (geometry: TGeometry) => geometry.rings.map((item) => ({
    rings: [item],
    spatialReference: geometry.spatialReference,
}));
